import React from 'react';
import '../../styles/App.css';
import weiboLogo from '../../images/weibo-icon-88.png';
import wechatLogo from '../../images/wechat-icon-88.png';
import sticker from '../../images/sticker.png';
import hare from '../../images/hare-grey.png';
import tortoise from '../../images/tortoise-grey.png';

let tr = require( '../../utils/translations' ).translate;

// STATIC FUNCTIONS
// =================================================================================================


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class AdvancedOptions extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		this.setGifWidth = this.setGifWidth.bind( this );
		this.setGifHeight = this.setGifHeight.bind( this );
		this.setFrameRate = this.setFrameRate.bind( this );
		this.toggleForcedAspectRatio = this.toggleForcedAspectRatio.bind( this );
	};


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {

		let AppState = this.props.App.state,
			VideoScene = this.props.VideoScene,
			size = 0;

		// GET ESTIMATION OF GIF FILE SIZE
		if ( !AppState.saveFrames && AppState.images && AppState.images.length
			&& ( VideoScene.expectedMessageCount === VideoScene.receivedMessageCount ) ) {
			AppState.images.forEach( function ( img ) {

				let head = 'data:image/gif;base64,';
				size += Math.round( ( img.length - head.length ) * 3 / 4 );
			} );

			size = ( size / 1000000 * 5 ).toFixed( 2 );

		} else size = false;


		{/*VIDEO META INFORMATION AND BUTTONS*/}
		{/*--------------------------------------------------------------------------------------*/}
		return <div className="video-meta-options">

			<p>{tr( 'Estimated Size:', '估算大小' )}<span>{size ? size + 'MB' :
				<div className="spinner spinner-small"/>}</span></p>

			{/* CUSTOM WIDTH AND HEIGHT WITH A CHECK FOR MAINTAINING ASPECT RATIO */}
			<div className="input-text-container">
				<div className="input-text">
					<input id="input-width"
						   type="text"
						   maxLength={255}
						   placeholder={tr( 'Gif Width', '' )}
						   defaultValue={AppState.canvasWidth || 0}
						   onInput={this.setGifWidth} />
				</div>

				<div className="input-text">
					<input id="input-height"
						   type="text"
						   maxLength={255}
						   placeholder={tr( 'Gif Height', '' )}
						   defaultValue={AppState.canvasHeight || 0}
						   onInput={this.setGifHeight} />
				</div>
			</div>

			<div className="input-checkbox">
				<input id="aspect-ratio" type="checkbox" onClick={this.toggleForcedAspectRatio}/>
				<label htmlFor="aspect-ratio">Maintain aspect ratio</label>
			</div>

			{/* TEXT INPUT FOR SETTING CUSTOM FRAME RATE */}
			<p>{ tr( 'Custom frame rate', '' )}</p>

			<div className="range-container">
				<img className="range-icon" src={tortoise}/>
				<input className="range"
					   type="range"
					   min="3"
					   max="60"
					   defaultValue={AppState.customFrameRate || 20}
					   onChange={this.setFrameRate}
				/>
				<img className="range-icon" src={hare}/>

				<div className="range-tip">{ ( AppState.customFrameRate || 20 ) + 'fps' }</div>
			</div>

			<div className="compatible-container">

				<div className="compatible-images">

					<div data-tooltip={tr( 'Weibo images need to be less than 4mb.', '微博贴图大小不能超过4mb' )}>
						<img width={32} height={32} src={weiboLogo} style={{
							opacity: size && size < 5 ? 1 : 0.2
						}}/>
						<p>{tr( 'Weibo', '微博' )}</p>

						<div className={( size < 5 ? 'tick' : 'cross' ) + ( size ? '' : ' grey' )}/>
					</div>

					<div data-tooltip={tr( 'WeChat Article images need to be less than 2mb.', '微信文章贴图大小不能超过2mb' )}>
						<img width={32} height={32} src={wechatLogo} style={{
							opacity: size && size < 2 ? 1 : 0.2
						}}/>
						<p>{tr( 'WeChat Article', '微信文章' )}</p>

						<div className={( size < 2 ? 'tick' : 'cross' ) + ( size ? '' : ' grey' )}/>
					</div>

					<div data-tooltip={tr( 'WeChat Stickers need to be less than 0.3mb.', '微信表情包大小不能超过0.3mb' )}>
						<img width={32} height={32} src={sticker} style={{
							opacity: size && size < 0.3 ? 1 : 0.2
						}}/>
						<p>{tr( 'WeChat Sticker', '微信表情包' )}</p>

						<div className={( size < .3 ? 'tick' : 'cross' ) + ( size ? '' : ' grey' )}/>
					</div>

				</div>
			</div>
		</div>
	}


	// UPDATE WITH WIDTH AND HEIGHT OF TEXT INPUTS IF THEY'VE CHANGED IN STATE
	// =============================================================================================
	componentDidUpdate() {
		let AppState = this.props.App.state;

		if ( !this.props.VideoScene.state.forceAspectRatio ) return false;

		let inputWidth = document.querySelector( '#input-width' ),
			inputHeight = document.querySelector( '#input-height' );

		if ( AppState.canvasWidth !== inputWidth.value )
			inputHeight.value = AppState.canvasHeight;

		else if( AppState.canvasHeight !== inputHeight.value )
			inputWidth.value = AppState.canvasWidth;

		inputHeight.value = AppState.canvasHeight;
		inputWidth.value = AppState.canvasWidth;
	}


	// =============================================================================================
	setGifWidth( e ) {
		let App = this.props.App,
			width = e.target.value;

		if ( width ) App.setState( prevState => ({ canvasWidth: width, axis: 'x' }), () => {

			this.props.VideoScene.selectQuality();
		});
	}


	// =============================================================================================
	setGifHeight( e ) {
		let App = this.props.App,
			height = e.target.value;

		if ( height ) App.setState( prevState => ({ canvasHeight: height, axis: 'y' }), () => {

			this.props.VideoScene.selectQuality();
		});
	}


	// =============================================================================================
	toggleForcedAspectRatio() {
		let VideoScene = this.props.VideoScene;

		VideoScene.setState( prevState => ({ forceAspectRatio: !VideoScene.state.forceAspectRatio }), () => {

			VideoScene.selectQuality();
		});
	}


	// =============================================================================================
	setFrameRate( e ) {
		let App = this.props.App,
			frameRate = e.target.value,
			rangeTip = document.getElementsByClassName( 'range-tip' )[0];


		// SHOW FPS DISPLAY TIP AND HIDE IT AFTER 3 SECONDS
		// -----------------------------------------------------------------------------------------
		rangeTip.style.display = 'initial';

		setTimeout( function() { rangeTip.style.display = 'none'; }, 3000 );

		// UPDATE STATE
		App.setState( prevState => ({ customFrameRate: frameRate || 6 }), () => {

			this.props.VideoScene.selectQuality();
		});
	}
}

export default AdvancedOptions;



// WEBPACK FOOTER //
// ./src/app/components/video/options-advanced.js